import { render } from "./NativeDisplayReporting.vue?vue&type=template&id=132e7f11&scoped=true"
import script from "./NativeDisplayReporting.vue?vue&type=script&lang=js"
export * from "./NativeDisplayReporting.vue?vue&type=script&lang=js"

import "./NativeDisplayReporting.vue?vue&type=style&index=0&id=132e7f11&lang=postcss&scoped=true"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132e7f11"]])

export default __exports__